import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import get from 'lodash.get';
import classNames from 'classnames';

import styles from './BuySharedTitle.scss';

function BuySharedTitleComponent({ buyPage, isAmp }) {
    const header = get(buyPage, 'meta.header');
    const headerClass = classNames(styles.header, { [styles.ampHeader]: isAmp });
    return (
        <h1 className={headerClass} data-tn="buy-page-header">
            {header}
        </h1>
    );
}

BuySharedTitleComponent.propTypes = {
    buyPage: PropTypes.shape({
        meta: PropTypes.shape({
            header: PropTypes.string.isRequired,
        }),
    }),
    isAmp: PropTypes.bool,
};

export const BuySharedTitle = createFragmentContainer(BuySharedTitleComponent, {
    buyPage: graphql`
        fragment BuySharedTitle_buyPage on ItemSearchQueryConnection {
            meta {
                header
            }
        }
    `,
});
